/**
 * A service for handling updates to locale settings.
 */
(function(){
  angular.module('core').factory('localeService', ['$locale', 'moment', 'edxLocalStorageService', 'localeSettingsService', 'lcidConstants', localeService]);

  function localeService($locale, moment, edxLocalStorageService, localeSettingsService, lcidConstants) {

    var LOCALE_CONFIG = {
      'en': {
        settings: localeSettingsService.enUSLocale,
        lcid: lcidConstants.ENGLISH_US
      },
      'en-gb': {
        settings: localeSettingsService.enGBLocale,
        lcid: lcidConstants.ENGLISH_GB
      },
      'es-mx': {
        settings: localeSettingsService.esMXLocale,
        lcid: lcidConstants.SPANISH_US
      }
    };

    function setLocale(locale) {
      if (!locale) {
        return;
      }

      var config = LOCALE_CONFIG[locale.toLowerCase()];
      if (config) {
        // If there exists a locale, update the $locale property.
        angular.extend($locale, config.settings());
      }
    }

    function getLocale() {
      return $locale.id;
    }

    function setLocaleFromLocalStorage() {
      var locale = edxLocalStorageService.getItem('locale');

      if (locale) {
        // Update the locale if there is one in localStorage.
        this.setLocale(locale);

        // Update the locale of moment, with the language as a fallback.
        var momentLocale = locale.toLowerCase();
        var momentLang = locale.split('-')[0];
        moment.locale([momentLocale, momentLang]);
      }
    }

    function updateLocaleForCountry(country) {
      if (!country) {
        return;
      }

      var countryToLocaleMap = {
        'GB': 'en-gb',
        'MX': 'es-mx'
      };

      var locale = Object.keys(countryToLocaleMap).includes(country) ? countryToLocaleMap[country] : 'en';
      this.setLocale(locale);
    }

    function updateLocaleFromCustomer(customer) {
      if (!customer) {
        return;
      }

      var effectiveLocale = customer.effective_dashboard_language;
      if (effectiveLocale && LOCALE_CONFIG[effectiveLocale.toLowerCase()]) {
        this.setLocale(effectiveLocale);
      } else {
        this.updateLocaleForCountry(customer.district_country);
      }
    }

    function getLcidFromCurrentLocale() {
      var currentLocale = edxLocalStorageService.getItem('locale') || 'en';
      var config = LOCALE_CONFIG[currentLocale.toLowerCase()] || LOCALE_CONFIG.en;
      return config.lcid;
    }

    return {
      getLocale: getLocale,
      setLocale: setLocale,
      setLocaleFromLocalStorage: setLocaleFromLocalStorage,
      updateLocaleForCountry: updateLocaleForCountry,
      updateLocaleFromCustomer: updateLocaleFromCustomer,
      getLcidFromCurrentLocale: getLcidFromCurrentLocale
    };
  }
})();
